<template>
	<v-list style="background: transparent" flat>
		<template v-for="item in nodes">
			<!-- Room -->
			<template v-if="isRoom(item)">
				<v-list-item
					:key="item.guid || item.meta.guid"
					class="device-list--item"
					dense
				>
					<v-list-item-title class="subtitle-1">{{
						item.name
					}}</v-list-item-title>

					<v-list-item-action>
						<EditMenu
							v-bind="{
								item,
								fnRemoveItem,
								fnRenameItem,
								fnMoveItem,
								isRoom,
								isEmptyRoom,
								isController,
							}"
							@update:showDeleteRoomSnackbar="
								$emit('update:showDeleteRoomSnackbar', true)
							"
						/>
					</v-list-item-action>
				</v-list-item>
			</template>

			<!-- Device -->
			<template v-else>
				<v-list-item
					:key="item.guid || item.meta.guid"
					class="device-list--item"
					:disabled="disable && isPaired(item)"
					@click="onListItemClick(item)"
				>
					<v-list-item-icon>
						<device-icon :device="item" :highlight="isPaired(item)" />
					</v-list-item-icon>
					<v-list-item-title>{{ item.name }}</v-list-item-title>

					<v-list-item-action>
						<template v-if="showNested && item.children.length">
							<v-btn icon @click.stop="toggleDrawer(item.meta.guid)">
								<v-icon>{{
									opened[item.meta.guid]
										? "fas fa-chevron-up"
										: "fas fa-chevron-down"
								}}</v-icon>
							</v-btn>
						</template>
						<EditMenu
							v-bind="{
								item,
								fnRemoveItem,
								fnRenameItem,
								fnMoveItem,
								isRoom,
								isEmptyRoom,
								isController,
							}"
						/>
					</v-list-item-action>
				</v-list-item>

				<!-- Child devices -->
				<template v-if="showNested && opened[item.meta.guid]">
					<v-list-item
						v-for="child in getNodesByGuid(item.children)"
						:key="child.meta.guid"
						class="device-list--item device-list--child"
						:disabled="disable"
						@click="onListItemClick(child)"
					>
						<v-list-item-icon>
							<device-icon :device="child" highlight />
						</v-list-item-icon>
						<v-list-item-title>{{ humanizeNodeName(child) }}</v-list-item-title>
					</v-list-item>
				</template>
			</template>
		</template>
	</v-list>
</template>

<style lang="scss" scoped>
.device-list--item {
	pointer-events: auto;

	&.device-list--child {
		padding-left: 40px;
	}

	.menu-icon {
		opacity: 0;
		transition: opacity 300ms;
	}

	&:hover .menu-icon {
		opacity: 1;
	}

	// Make sure action icons stack horizontally
	.v-list-item__action.v-list-item__action--stack {
		flex-direction: row;
	}
}
</style>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

import {
	humanizeNodeName,
	DEVICE_CLASS_ROOM,
	DEVICE_CLASS_CONTROLLER,
} from "@/utils/k4util";

import EditMenu from "./EditMenu";

export default {
	components: { EditMenu },

	props: {
		nodes: { type: Array, default: () => [] },
		showNested: { type: Boolean, default: false },

		fnRemoveItem: { type: Function, required: true },
		fnRenameItem: { type: Function, required: true },
		fnMoveItem: { type: Function, required: true },

		fnClickItem: { type: Function, required: true },
		showDeleteRoomSnackbar: { type: Boolean, default: false },

		disable: Boolean,
	},

	data: () => ({
		opened: {},
		loaded: false,
	}),

	computed: {
		...mapGetters({ nodeByGuid: "controller/nodes/nodeByGuid" }),
	},

	watch: {
		"nodes.0"(node) {
			this.loaded = !!node;
		},

		loaded(val) {
			if (val) {
				this.$emit("loaded");
			}
		},
	},

	methods: {
		humanizeNodeName,

		isRoom(item) {
			const cls = item.meta ? item.meta.cls : item.cls;
			return cls === DEVICE_CLASS_ROOM;
		},

		// temporary - we cant move or rename controllers because of issue with controller code
		isController(item) {
			const cls = item.meta ? item.meta.cls : item.cls;
			return cls === DEVICE_CLASS_CONTROLLER;
		},

		isEmptyRoom(item) {
			return !item.children.length;
		},

		isPaired(item) {
			return item.configured;
		},

		onListItemClick(item) {
			if (this.isRoom(item)) {
				item = undefined;
			}
			this.selectedItem = item;
			this.fnClickItem(item);
		},

		getNodesByGuid(guids) {
			return _.map(guids, this.nodeByGuid);
		},

		toggleDrawer(guid) {
			const open = this.opened[guid];
			this.opened = {
				...this.opened,
				[guid]: !open,
			};
		},
	},
};
</script>
